<template>
  <section>
    <div class="table-responsive">
      <table class="table p-0 m-0 dataTable no-footer min-h-[150px] text-nowrap">
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold" width="22%">
              Name
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Code
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              State
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Created
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Actions
            </th>
          </tr>
        </thead>

        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px">
                  Please wait while we load your distributor's list
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="m in distributors" :key="m.id" v-else>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ m.name }}
            </td>
            <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
              {{ m.code }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ m.state }}
            </td>
            <td>
              <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                'badge',
                { 'badge-success': m.isOnboarded, 'badge-danger': !m.isOnboarded },
              ]">
                <span class="w-[10px] h-[10px] rounded-[1px]"
                  :style="{ backgroundColor: m.isOnboarded ? '#16a249' : '#EF5253' }"></span>
                <span class="text-[12px] font-normal leading-[16.94px]">{{
                  m.isOnboarded ? "Active" : "Inactive"
                }}</span>
              </span>
            </td>

            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ formatDate(m.created) }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              <button class="text-[14px] font-normal leading-[16.94px] outline-none focus:outline-none text-[#96A0B5]"
                v-if="hasPermission('Distributor_View')" @click="viewDistributor(m)">
                View
              </button>
            </td>
          </tr>

          <tr v-if="!distributors.length && !loading">
            <td colspan="12">
              <div class="text-center" style="padding-top: 50px">
                <span style="font-size: 4.615rem" class="fa-solid fa-truck text-[#2463EB]"></span>
              </div>
              <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]" style="padding-bottom: 100px">
                You don't have any distributors.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <DistributorModal :isModalVisible="isModalVisible" :selectedDistributor="selectedDistributor" @close="closeModal"
      @check-balance="checkBalance" />

    <div class="modal fade py-1 bg-[rgba(0,0,0,0.5)] z-[1112]" id="mod-balance" role="dialog">
      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <button class="absolute right-6 top-4 text-2xl" type="button" data-dismiss="modal" aria-hidden="true">
            <span class="mdi mdi-close"></span>
          </button>
          <h3 class="text-[16px] font-medium text-[#353535]">{{ selectedDistributor.name }}</h3>
          <div v-if="balance" class="flex flex-col md:flex-row items-start gap-1 md:items-center md:gap-4 mt-2">
            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-max w-full">
              Distributor's Available Balance
            </h2>
            <span :class="[
              'font-medium text-[16px] leading-[19.36px]',
              balance.endsWith('-') ? 'text-green-500' : 'text-red-500'
            ]">
              ₦{{ formatBalance(balance) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import SystemPermissions from "@/permissions";
import { helper } from "@/helper";
import DistributorModal from './DistributorModal.vue';

export default {
  mixins: [SystemPermissions.Mixin],
  components: {
    DistributorModal
  },
  props: ["distributors", "loading", "viewDetails"],
  data() {
    return {
      isModalVisible: false,
      sendingInvite: false,
      isBusy: false,
      selectedDistributor: {},
      pageNumber: 0,
      pageSize: 10,
      name: "",
      active: "",
      code: "",
      isLoading: false,
      balance: "",
    };
  },
  methods: {
    async checkBalance() {
      await this.getDistributorCreditInformation()
      $("#mod-balance").modal("show");
    },
    async getDistributorCreditInformation() {
      let url = "/Accounts/getDistributorCreditInformation";
      let accountId = this.selectedDistributor.id;
      try {
        const res = await this.$http.get(
          `${url}/${accountId}`
        );
        const data = await res.json();
        if (data) {
          this.balance = data.exposureAmount;
        }
      } catch (err) {
      }
    },
    formatBalance(val) {
      if (!val) return '';
      const isNegative = val.endsWith('-');
      const cleanVal = isNegative ? val.slice(0, -1) : val;
      return parseFloat(cleanVal).toLocaleString('en-NG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async getDistributor(id) {
      this.isBusy = true;
      try {
        const response = await this.$http.get("/Accounts/getById/" + id);
        this.isBusy = false;
        if (response.ok) {
          return response.body;
        } else {
          throw {};
        }
      } catch (error) {
        this.isBusy = false;
      }
    },
    async getGroupPriceOptions(id) {
      this.isBusy = true;
      try {
        const response = await this.$http.get("/Groups/getPriceOptions/" + id);
        if (response.ok && response.status === 200) {
          let body = await response.json();
          this.priceOptions = body.data;
          this.pageNumber = body.pageNumber;
          this.pageSize = body.pageSize;
          this.count = body.count;
          this.hasPrev = body.hasPrev;
          this.hasNext = body.hasNext;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    async viewDistributor(distributor) {
      try {
        const response = await this.$http.get(`/Accounts/getById/${distributor.id}`);
        const data = await response.json();
        this.isModalVisible = true;
        this.selectedDistributor = data;
        this.name = this.selectedDistributor.name;
        this.code = this.selectedDistributor.code;
        this.active = this.selectedDistributor.active;
        const accountInfo = await this.getDistributor(this.selectedDistributor.id);
        let groupId = accountInfo.group.id;
        await this.getGroupPriceOptions(groupId);
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
    openModal() {
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
  },
};
</script>